/**
 * @ngdoc component
 * @name BaseErrorPageComponent
 * @module MKErrorPageModule
 */

export class BaseErrorPageComponent {
    public title: string;
    public message: string;
    public linkText: string;
    public link: string;
}
